import Vue from 'vue';

// other components can listen on this event to do something they want,
// and receive data from arguments.
// example:
// in component A's method
// eventBus.$emit('id-selected', 1)
// ...
// in component B's created hook
// eventBus.$on('id-selected', function (id) {

const eventBus = new Vue({
  data: {
    // define data for eventBus
  },
  methods: {
    // define event methods
  }
});


Object.defineProperty(Vue.prototype, '$eventBus', {
  get() {
    return eventBus;
  }
});

export default eventBus;
